const getDLQMessageProxySuccessType = 'GET_DLQ_MESSAGE_PROXY_SUCCESS_TYPE';


export {
    getDLQMessageProxySuccessType
}